import React, { Component } from "react";

class DeleteAccountRequest extends Component {

    showInfo = () => {
        alert("You can delete your account from the main menu of the app by clicking on DELETE ACCOUNT. If you need assitance deleting your account please contcat support at artblastai@scifork.com with")
        window.location.replace("https://app.artblastai.com")
    }

    render() {
        return (
            <div>
                {this.showInfo()}
            </div>
        );
    }
}

export default DeleteAccountRequest